import React from "react";
import {Browser} from "react-kawaii";
import Grid from "../sublayouts/components/bootstrap/grid";
import Row from "../sublayouts/components/bootstrap/row";
import Col from "../sublayouts/components/bootstrap/col";
import "../style/bs.scss";

export default function Error404() {
  return (<Grid>
    <Row className="align-items-center" style={{height: "100vh"}}>
      <Col style={{textAlign: "center"}} xs="auto" className="mx-auto">
        <Browser size={200} mood="sad" color="#83D1FB" />
        <div style={{marginTop: 50, fontSize: 32, fontWeight: 300}}>
          {"404"}
        </div>
        <div style={{marginTop: 10, fontSize: 18}}>
          {"The page you have requested is not available"}
        </div>
      </Col>
    </Row>
  </Grid>);
}
